import {
  FirebaseApp,
  getApps,
  initializeApp,
  registerVersion,
} from "firebase/app";
import { inMemoryPersistence, initializeAuth } from "firebase/auth";
import React from "react";

import firebaseConfig from "./config";

const FirebaseAppContext = React.createContext<FirebaseApp | undefined>(
  undefined,
);

const appName = "weld-editor";

export function getWeldFirebaseApp() {
  const existingApp = getApps().find((app) => app.name === appName);
  if (existingApp) {
    return existingApp;
  }
  registerVersion("react", React.version || "unknown");
  return initializeApp(firebaseConfig, appName);
}

/**
 * In-memory from the start, so sign-in does not first wait on `getAuth` probing IndexedDB
 * persistence. Anything calling `getAuth` on this app before it makes it throw.
 */
export function getWeldAuth() {
  return initializeAuth(getWeldFirebaseApp(), {
    persistence: inMemoryPersistence,
  });
}

export function FirebaseAppProvider(props: React.PropsWithChildren) {
  const firebaseApp = React.useMemo(() => getWeldFirebaseApp(), []);

  return (
    <FirebaseAppContext.Provider value={firebaseApp}>
      {props.children}
    </FirebaseAppContext.Provider>
  );
}

export function useFirebaseApp() {
  const firebaseApp = React.useContext(FirebaseAppContext);
  if (!firebaseApp) {
    throw new Error(
      "Cannot call useFirebaseApp unless your component is within a FirebaseAppProvider",
    );
  }
  return firebaseApp;
}
